import { defineComponent as _defineComponent } from 'vue'
import HeaderSearch from './search/HeaderSearch.vue';
import HeaderTags from './tags/HeaderTags.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ImageEffectsPropertiesCreateHeader',
  setup(__props) {


return { __sfc: true,HeaderSearch, HeaderTags }
}

})